function canUseSessionStorage(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    return typeof window.sessionStorage !== 'undefined';
  } catch {
    return false;
  }
}

function getBoolean(key: string): boolean {
  if (!canUseSessionStorage()) {
    return false;
  }

  try {
    return window.sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

function setBoolean(key: string, value: boolean) {
  if (!canUseSessionStorage()) {
    return;
  }

  try {
    if (value) {
      window.sessionStorage.setItem(key, '1');
      return;
    }
    window.sessionStorage.removeItem(key);
  } catch {
    // Ignore storage access errors in restricted browser contexts.
  }
}

function getString(key: string): string | null {
  if (!canUseSessionStorage()) {
    return null;
  }

  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function setString(key: string, value: string | null) {
  if (!canUseSessionStorage()) {
    return;
  }

  try {
    if (!value) {
      window.sessionStorage.removeItem(key);
      return;
    }
    window.sessionStorage.setItem(key, value);
  } catch {
    // Ignore storage access errors in restricted browser contexts.
  }
}

export { getBoolean, setBoolean, getString, setString };
